import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/config/query-client'
import { AuthProvider } from '@/features/auth/components'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  )
}
